import { component, Context } from 'picoapp';
import Toast from 'utils/toast';
import { repaint } from 'utils/node';
import Timer from 'utils/timer';

export default component((node: HTMLFormElement, ctx: Context) => {
  const toast = Toast(node);
  const imgElement: HTMLImageElement = node.querySelector('[data-image-placeholder]');

  if (!toast) return;

  const close = () => {
    toast.close();

    setTimeout(() => {
      imgElement.src = '';
      imgElement.hidden = true;
    }, 1000); // prevents previous product image to be shown for a second
  };

  const CloseTimer = Timer(close, 10000);

  document.addEventListener('cart:product:added', (e: CustomEvent) => {
    const { image }: { image: string | null } = e.detail;

    if (image && imgElement) {
      imgElement.src = image;
      imgElement.hidden = false;
      repaint(imgElement);
    }

    toast.open();

    CloseTimer.init();
  });

  node.addEventListener('mouseenter', () => CloseTimer.pause());
  node.addEventListener('mouseleave', () => CloseTimer.resume());

  ctx.on('cart:update', async ({ openDrawer }) => {
    // we want to close the toast if the drawer opens
    if (openDrawer) close();
  });

  toast.on('closed', () => {
    // stop the timeout if toast is closed manually
    // or else the timer will be inherited by the next toast
    CloseTimer.stop();
  });
});
